<template>
    <div class="pa-2">
        <v-item-group active-class="zoezi-edit-color" v-model="selectedPageTemplate">
            <v-row v-for="(row, rowindex) in rows" :key="rowindex">
                <v-col :cols="12 / columns" v-for="template in row" :key="template.id">
                    <v-item :value="template" v-slot:default="{ active }">
                        <v-hover v-slot="{hover}">
                            <v-card
                                width=200
                                :elevation="hover ? 24 : 6"
                                :class="active || hover ? ['zoezi-edit-color'] : undefined"
                                ripple
                                @click="selectedPageTemplate = template; $emit('input', template)"
                            >
                                <v-btn v-if="showRemove && isSuperUser && hover" icon @click="remove(template)" class="float-right" color="white"><v-icon class="">mdi-close</v-icon></v-btn>
                                <v-card-text justify="center" align="center" :class="(active||hover) ? 'zoezi-edit-text-color' : undefined">
                                    <v-icon :class="(active||hover) ? 'zoezi-edit-text-color' : ''">{{template.icon}}</v-icon><br>
                                    {{template.name}}
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </v-item>
                </v-col>
            </v-row>
        </v-item-group>
    </div>
</template>

<script>
import {chunk} from 'lodash';
export default {
    name: 'PageTemplatePalette',
    props: {
        value: {},
        showRemove: {
            type: Boolean
        }
    },

    watch: {
        value() {
            this.selectedPageTemplate = this.value;
        }
    },

    computed: {
        rows() {
            return chunk(this.pageTemplates, this.columns);
        },
        isSuperUser() {
            return this.$store.state.isLoggedIn && this.$store.state.user && this.$store.state.user.superUser;
        }
    },

    data: () => ({
        columns: 2,
        pageTemplates: [],
        selectedPageTemplate: null
    }),
    methods: {
        getTemplates() {
            this.$api.get('/api/homepage/pagetemplate/get').then(x => this.pageTemplates = x);
        },
        remove(template) {
            this.$store.commit('showConfirmDialog', {
                title: this.$translate('Remove page template'),
                text: this.$translate('Are you sure you want to remove the page template {0}?').format(template.name),
                actionText: this.$translate('Remove'),
                action: () => {
                    this.$api.post('/api/homepage/pagetemplate/remove', null, {id: template.id}).then(() => {
                        this.getTemplates();
                    })
                }
            });
        }
    },
    mounted() {
        this.getTemplates();
    }
}
</script>
